import React, { createContext, useState, ReactNode } from "react";

export interface ITableRowContextProps {
  isHeaderRow: boolean;
  hasImage: boolean;
  setIsHeaderRow: (isHeaderRow: boolean) => void;
  setHasImage: (hasImage: boolean) => void;
}

const defaultTableRowContext: ITableRowContextProps = {
  isHeaderRow: false,
  hasImage: false,
  setIsHeaderRow: () => {},
  setHasImage: () => {},
};

export const TableRowContext = createContext(defaultTableRowContext);

export interface ITableRowProviderProps {
  children: ReactNode;
}

export const TableRowProvider: React.FC<ITableRowProviderProps> = ({ children }) => {
  const [isHeaderRow, setIsHeaderRow] = useState(defaultTableRowContext.isHeaderRow);
  const [hasImage, setHasImage] = useState(defaultTableRowContext.hasImage);

  return (
    <TableRowContext.Provider value={{ isHeaderRow, setIsHeaderRow, hasImage, setHasImage }}>
      {children}
    </TableRowContext.Provider>
  );
};
